"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QR_CODE_WIDTH = exports.QR_CODE_HEIGHT = void 0;
const QR_CODE_HEIGHT = exports.QR_CODE_HEIGHT = 120;
const QR_CODE_WIDTH = exports.QR_CODE_WIDTH = 100;